import React, { FC, useEffect, useRef } from 'react';
import PollEntity from '../../../store/polls-store/poll-entity';
import ResponseEntity from '../../../store/polls-store/response-entity';
import PollFullScreen from '../poll-full-screen/poll-full-screen';
import EmptyList from '../shared/empty-list';
import { isSafari } from '../../../constans/url-constants';

interface IProps {
  selectedPoll: PollEntity | null;
  isListEmpty: boolean;
  isFullScreenModeEnabled: boolean;
  getPollChoisesList: (pollId: string) => Promise<ResponseEntity[] | void>;
  toggleManagePollModal: () => void;
  setShouldShowFullScreen: (value: boolean) => void;
  setIsFullScreenModeSafari: (value: boolean) => void;
  isFullScreenModeSafari: boolean;
}

const NotSelectedPollInfo: React.FC = () => {
  return (
    <div className='manage-list-container'>
      <div className='manage-list-info-text'>Select a Poll from a list.</div>
    </div>
  );
};

const PollsContentManagerWrapper: FC<IProps> = ({
  selectedPoll,
  isListEmpty,
  toggleManagePollModal,
  children,
  isFullScreenModeEnabled,
  getPollChoisesList,
  setShouldShowFullScreen,
  setIsFullScreenModeSafari,
  isFullScreenModeSafari,
}) => {
  const wrapperClassName = `polls-content-manager-wrapper ${!isListEmpty && selectedPoll ? 'bg-white' : 'bg-grey'}`;
  const ref = useRef(null);

  const closeFullScreenMode = (): void => {
    if (isSafari) {
      setIsFullScreenModeSafari(false);
    }
    setShouldShowFullScreen(false);
  };

  const escExitFullscreen = () => {
    // @ts-ignore
    const noBrowserFullscreen = !document.fullscreenElement && !document.webkitIsFullScreen && !document.msFullscreenElement && !document.mozFullScreen;

    if (noBrowserFullscreen) {
      closeFullScreenMode();
    }
  };

  const addFullScreenEventListener = (): void => {
    document.addEventListener('webkitfullscreenchange', escExitFullscreen);
    document.addEventListener('mozfullscreenchange', escExitFullscreen);
    document.addEventListener('fullscreenchange', escExitFullscreen);
    document.addEventListener('MSFullscreenChange', escExitFullscreen);
  };

  const removeFullScreenEventListener = (): void => {
    document.removeEventListener('fullscreenchange', closeFullScreenMode);
    document.removeEventListener('webkitfullscreenchange', closeFullScreenMode);
    document.removeEventListener('mozfullscreenchange', closeFullScreenMode);
    document.removeEventListener('MSFullscreenChange', closeFullScreenMode);
  };

  useEffect(() => {
    addFullScreenEventListener();

    return () => {
      removeFullScreenEventListener();
    };
  }, []);

  const renderWrapperContent = () => {
    if (children) {
      return children;
    }

    return isListEmpty
      ? <EmptyList toggleManagePollModal={toggleManagePollModal}/>
      : (!selectedPoll && <NotSelectedPollInfo/>);
  };

  return (
    <div className={wrapperClassName} ref={ref}>
      {renderWrapperContent()}

      {isFullScreenModeEnabled &&
        <PollFullScreen
          poll={selectedPoll}
          getPollChoisesList={getPollChoisesList}
          closeFullScreenMode={closeFullScreenMode}
          isFullScreenModeSafari={isFullScreenModeSafari}
        />
      }
    </div>
  );
};

export default PollsContentManagerWrapper;
